import axios from 'axios'
import store from '@/store/index'
import router from '@/router/index.js'

const onSuccess = (response) => {
  if(response.data && response.data.data) {
    return Promise.resolve(response.data.data);
  } else {
    return Promise.reject(response);
  }
}

const onError = (e) => {
  switch(e.response.status) {
    case 401:
      if (e.response.config.url.match(/sign_in/) == null) {
        router.replace('/sign_in')
      }
      break
    case 503:
      router.replace('/503')
      break
  }
  return Promise.reject(e.response);
}

export default {
  baseUrl() {
    return process.env.BASE_PROTOCOL + '://' + process.env.BASE_ADDRESS + '/';
  },

  get: function (url, requestVars) {
    return axios.get(this.baseUrl() + url, {
      headers: {
        'Authorization': 'Bearer ' + store.state.auth.appToken
      },
      params: requestVars
    })
      .then(onSuccess)
      .catch(onError)
  },

  post: function (url, params = null) {
    return axios.post(this.baseUrl() + url, params, { headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + store.state.auth.appToken
    } })
      .then(onSuccess)
      .catch(onError)
  },

  patch: function (url, params) {
    return axios.patch(this.baseUrl() + url, params, { headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + store.state.auth.appToken
    } })
      .then(onSuccess)
      .catch(onError)
  },

  delete: function (url) {
    return axios.delete(this.baseUrl() + url, { headers: {
      'Authorization': 'Bearer ' + store.state.auth.appToken
    } })
      .then(onSuccess)
      .catch(onError)
  }
}
